
import moment from "moment";

export default {
    methods: {
        changeDateFormatTo_DD_MM_YYYY(date){
          return moment(date).format("DD-MM-YYYY");
        }
    }
}